import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const onFailedToRescheduleProductionOperationsAction = (
  state: PlanboardState,
  action: PayloadAction<{
    requestCorrelationId?: string;
    errorMessage?: string;
  }>
) => {
  const { requestCorrelationId, errorMessage } = action.payload;

  if (!requestCorrelationId) {
    return;
  }

  // OperationId-first: Find which operation has this correlationId
  const operationEntry = Object.entries(state.pendingOperations).find(
    ([, pending]) => pending.correlationId === requestCorrelationId
  );

  if (!operationEntry) {
    // Check if this correlationId is in any ignored list (stale event)
    const isIgnored = Object.values(state.pendingOperations).some((pending) =>
      pending.ignoredCorrelationIds.includes(requestCorrelationId)
    );
    if (isIgnored) {
      return; // Stale event from a previous drag
    }
    // Not tracking this correlation - ignore
    return;
  }

  const [operationIdStr] = operationEntry;
  const operationId = Number(operationIdStr);

  // Store error for UI display
  state.lastRescheduleError = {
    correlationId: requestCorrelationId,
    errorMessage,
  };

  // Remove from pending operations
  delete state.pendingOperations[operationId];
};
